export const TRANSLATION_FIELDS_LOADING_TESTID = 'translation-fields-loading';

export const TranslationFieldsLoading = () => (
  <div className='flex flex-col gap-4' data-testid={TRANSLATION_FIELDS_LOADING_TESTID}>
    <div className='h-10 w-full animate-pulse rounded-md bg-secondary' />
    <div className='h-[46px] w-full animate-pulse rounded-md bg-secondary' />
    <div className='h-[130px] w-full animate-pulse rounded-md bg-secondary' />
  </div>
);
